export { COMPONENTS_MODULE_NAME, DETAILS_DIRECTIVE_NAME, CREATE_EDIT_DIRECTIVE_NAME } from "./packages.components.module"
export { PackageConfirmOpitons, IPackageConfirm } from "./package-confirm/package-confirm.interfaces"